<template>
    <v-form name="create-order-form">
        <div class="grid">
            <FormInputText fieldName="order_name"
                           label="Order name"
                           validation="required"
                           v-model:field="order_name" />
        </div>
        <div class="grid">
            <FormSelect fieldName="contractor_id"
                        label="Contractor"
                        validation="required"
                        :options="select?.contractors"
                        v-model:field="contractor_id" />
        </div>
        <div class="grid">
            <FormEditor fieldName="description"
                        label="Description"
                        v-model:field="description" />
        </div>

        <div class="grid"
             style="margin-top:20px">
            <Button @click.stop="createOrder"
                    :class="buttonClass('green')">
                <template class="flex items-center gap-1"><i class="fa-regular fa-floppy-disk"></i><span>{{ __('Save') }}</span></template>
            </Button>

            <Button @click="cancel"
                    :class="buttonClass('gray')">
                <template class="flex items-center gap-1"><i class="fa-regular fa-trash-can"></i><span>{{ __('Cancel') }}</span></template>
            </Button>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useForm, usePage } from '@inertiajs/vue3'
import Button from 'primevue/button';
import FormInputText from '@crud/FormInputText.vue'
import FormSelect from '@crud/FormSelect.vue'
import FormEditor from '@crud/FormEditor.vue'
import { __, buttonClass } from '@pages/Helper/utils.js'
import { validation, prepareSelect } from '@pages/Helper/crud_utils.js'

// -----------------------------------------------------
const props = defineProps({
    selectedRows: Array,
    formProps: Object
})

const isLoading = ref(false)
const page = usePage()
const order_name = ref(null)
const contractor_id = ref(null)
const description = ref(null)
const select = ref(null)
const options = ['contractors'];
const isCreateOrderModalOpen = defineModel('isCreateOrderModalOpen')

// -----------------------------------------------------

onMounted(async () => {
    select.value = await prepareSelect(options, null, null, { 'contractors': { 'custom_type': 'SUPPLIERS' } })
})
// -----------------------------------------------------

const cancel = () => {
    isCreateOrderModalOpen.value = false
}
// -----------------------------------------------------

const createOrder = async () => {
    const products = props.selectedRows.map(row => ({ product_id: row.product_id, offer_id: row.offer_id, quantity: row.quantity, section: row.section }))
    const formData = {
        'products': products,
        'order_name': order_name.value,
        'contractor_id': contractor_id.value,
        'description': description.value,
    }

    if (validation(formData, 'create-order-form')) {
        isLoading.value = true

        useForm(formData).post(route('order-create-from-offers'), {
            preserveState: true,
            preserveScroll: true,
            forceFormData: true,
            onSuccess: () => {
            },
            onError: (errors) => {
                console.error(errors)
            },
            onFinish: () => {
                isLoading.value = false
                isCreateOrderModalOpen.value = false
                props.formProps.getLazyData()
                props.formProps.clearSelection()
            }
        })
    }
}
// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
